<template>
  <b-row v-if="breadcrumb.length > 0" class="content-header">
    <b-col class="content-header-left" cols="12">
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <div class="breadcrumb-wrapper custom-bc">
            <b-breadcrumb>
              <b-breadcrumb-item
                v-for="item in breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
  import {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
  } from 'bootstrap-vue';

  import Ripple from 'vue-ripple-directive';
  import router from '@/router/index';
  // import { useRouter } from '@/@core/utils/utils';
  import {
    watch,
    onBeforeMount,
    ref,
    getCurrentInstance,
    reactive,
  } from '@vue/composition-api';
import store from '@/store';

  export default {
    directives: {
      Ripple,
    },
    components: {
      BBreadcrumb,
      BBreadcrumbItem,
      BRow,
      BCol,
      BDropdown,
      BDropdownItem,
      BButton,
    },
    setup() {
      const breadcrumb = ref([]);
      const vm = getCurrentInstance().proxy;
      // const { router: } = useRouter();

      const initBreadcrumb = () => {
        const allRoute = router.options.routes;

        const pathRegex = router.currentRoute.matched[0]?.regex || null;

        if (pathRegex) {
          const currentRouteInfo = allRoute.find((route) => {
            return pathRegex.test(route.path);
          });

          if (currentRouteInfo?.breadcrumb) {
            return (breadcrumb.value = currentRouteInfo.breadcrumb);
          }
        }
        return (breadcrumb.value = []);
      };

      watch(store.getters['appConfig/breadCumb'], () => {
        initBreadcrumb();
      },{deep:true})

      onBeforeMount(() => {
        initBreadcrumb();
      });

      return { breadcrumb };
    },
  };
</script>

<style>
  .custom-bc {
    width: fit-content;
  }

  .content-header-title {
    border-right: 1px solid #d6dce1;
  }

  .breadcrumb {
    font-size: 28px;
    padding: 0 10px;
  }

  .breadcrumb:not([class*='breadcrumb-'])
    .breadcrumb-item
    + .breadcrumb-item:before {
    background-size: 25px;
    margin: 10px 14px 0 8px;
  }

  .breadcrumb-item > a {
    color: var(--header-bar-text-color);
  }

  .breadcrumb-item > span {
    color: var(--header-bar-text-color);
  }

  .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {
    background-image: unset !important;
    content : ">";
    color: var(--header-bar-text-color);
    margin: 0 0.5rem;
  }
</style>
